import React, { useState } from 'react';
import { ChevronRight, Sparkles, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const GoldJewellery = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const navigate = useNavigate();

  const goldItems = [
    {
      id: 1,
      name: "Designer Gold Ring",
      category: "Gold Ring",
      image: "https://www.giva.co/cdn/shop/products/GDLR0245_5.jpg?v=1699510483&width=940",
      description: "Exquisite designer gold ring with intricate patterns"
    },
    {
      id: 2,
      name: "Classic Gold Ring",
      category: "Gold Ring",
      image: "https://tse2.mm.bing.net/th/id/OIP.SwbBLAnmnqat_W5Oz5VPqwHaHa?w=2000&h=2000&rs=1&pid=ImgDetMain&o=7&rm=3",
      description: "Timeless classic gold ring for everyday elegance"
    },
    {
      id: 3,
      name: "Embossed Gold Ring",
      category: "Gold Ring",
      image: "https://www.giva.co/cdn/shop/products/GDLR0189_5_dd279bdc-5326-4e88-9738-a013949e42ba.jpg?v=1699522725&width=360",
      description: "Beautiful embossed pattern gold ring"
    },
    {
      id: 4,
      name: "Royal Signet Ring",
      category: "Gold Ring",
      image: "https://www.giva.co/cdn/shop/files/GDLR0168_5.jpg?v=1690462395",
      description: "Royal signet ring with traditional design"
    },
    {
      id: 5,
      name: "Gold Necklace & Earring Set",
      category: "Gold Necklace Set",
      image: "https://tse4.mm.bing.net/th/id/OIP.eFnEDbpnu9oRd5xUkX2W3AHaHa?rs=1&pid=ImgDetMain&o=7&rm=3",
      description: "Complete necklace and earring set"
    },
    {
      id: 6,
      name: "Bridal Gold Jhumka Set",
      category: "Gold Jhumka Set",
      image: "https://i.pinimg.com/736x/c1/13/9a/c1139a3b3bb75f6720db462ddca43b15.jpg",
      description: "Traditional bridal jhumka earrings set"
    },
    {
      id: 7,
      name: "Heritage Gold Necklace",
      category: "Gold Necklace",
      image: "https://i.pinimg.com/originals/d0/b4/d5/d0b4d5c4053efec033de5f6424c8be52.jpg",
      description: "Heritage style gold necklace"
    },
    {
      id: 8,
      name: "Gold Pendant Necklace",
      category: "Gold Pendant Set",
      image: "https://5.imimg.com/data5/SELLER/Default/2023/12/369366146/MD/PA/XQ/87896904/gold-necklace-set-500x500.jpg",
      description: "Elegant gold pendant necklace"
    },
    {
      id: 9,
      name: "Antique Gold Choker",
      category: "Gold Choker Necklace",
      image: "https://southindiajewels.com/wp/wp-content/uploads/2017/08/Antique-short-choker-rohit-jewellers.jpg",
      description: "Antique design gold choker"
    },
    {
      id: 10,
      name: "Traditional Gold Bridal Set",
      category: "Gold Bridal Set",
      image: "https://5.imimg.com/data5/SELLER/Default/2023/7/329744320/OH/XW/RL/121702256/gold-necklace-set-1000x1000.jpg",
      description: "Complete bridal jewellery set"
    },
    {
      id: 11,
      name: "Gold Temple Necklace",
      category: "Gold Temple Jewellery",
      image: "https://southindiajewels.com/wp/wp-content/uploads/2016/04/Beautiful-gold-temple-necklace-naj.jpg",
      description: "Temple style gold necklace"
    },
    {
      id: 12,
      name: "Traditional Gold Mangalsutra",
      category: "Gold Mangalsutra",
      image: "https://n4.sdlcdn.com/imgs/h/m/p/Indian-Mangalsutra-22K-Gold-Plated-SDL080302059-1-cbfd6.jpeg",
      description: "Traditional gold mangalsutra"
    }
  ];

  const handleInquire = (itemName, itemCategory) => {
    navigate('/contact', { 
      state: { 
        productName: itemName,
        productCategory: itemCategory,
        inquiryType: 'product'
      } 
    });
  };
  return (
    <section className="py-16 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <Sparkles className="text-[#846358]" size={32} />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Gold Jewellery</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Timeless elegance, crafted in pure gold.
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#846358] to-[#c49a6c] mx-auto mt-6 rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {goldItems.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 group"
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <div className="relative overflow-hidden h-64 bg-gray-100">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute top-3 left-3 bg-[#846358] text-white text-xs font-semibold px-2 py-1 rounded-full">
                  {item.category}
                </div>
                {hoveredItem === item.id && (
                  <div className="absolute inset-0 bg-black/50 flex items-center justify-center transition-opacity duration-300">
                    <button
                      onClick={() => handleInquire(item.name, item.category)}
                      className="bg-[#846358] hover:bg-[#6d5348] text-white px-6 py-2 rounded-full font-semibold transform transition-all duration-300 hover:scale-105 flex items-center gap-2"
                    >
                      <Eye size={16} />
                      Quick View
                    </button>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold text-gray-800 mb-2">{item.name}</h3>
                <p className="text-gray-500 text-sm mb-4 line-clamp-2">{item.description}</p>
                <button
                  onClick={() => handleInquire(item.name, item.category)}
                  className="w-full bg-[#846358] hover:bg-[#6d5348] text-white px-4 py-2 rounded-lg font-semibold transition-all duration-300 flex items-center justify-center gap-2 group"
                >
                  Inquire Now
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <button className="bg-[#846358] hover:bg-[#6d5348] text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg">
            View All Gold Jewellery
          </button>
        </div>
      </div>
    </section>
  );
};

export default GoldJewellery;